import React, { useEffect } from 'react';
import './HomeCom.scss';

import AOS from 'aos';
import 'aos/dist/aos.css';


import resume from '../../assets/Other/Resume(Raj).pdf';

import star_img from "../../assets/star_icon.svg";

import eight_star from "../../assets/eight-pointed-black-star.svg";







const HomeCom = () => {

  useEffect(() => {
    AOS.init({
      duration: 900, 
      debounceDelay: 50, 

      
      once: false, 
      mirror: true, 

    });
  }, []);

  const Greetings = () => {
    const myDate = new Date();
    const hours = myDate.getHours();
    let greet;

    if (hours < 12) greet = 'Morning';
    else if (hours >= 12 && hours <= 17) greet = 'Afternoon';
    else if (hours >= 17 && hours <= 24) greet = 'Evening';

    return greet;
  };


  return (
    <section className="home_cls">

      <div className="home_cntr">

        <div className="row">

          <div className="home_txt">
            <h3 className="greeting">Good {Greetings()}<span>👋</span>, This is</h3>

            <div class="my-name">
              <div class="title1">
                <h1>RAJ CHHALOTRE</h1>
              </div>
              <div class="ghost">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            <h2>Web Developer<span> <img src={eight_star} /> </span>ML enthusiast<span> <img src={eight_star} /> </span>Problem Solver
    

            </h2>
            <h4>Welcome to My <span3>Portfolio Website !!!</span3></h4>
          </div>


          <div className="btn_ctnr">
            <a href={resume} target='_blank' rel="noreferrer">View Resume </a>
          </div>


        </div>

      </div>


      {/* <img src={star_img} alt="" class="star_icon1" /> */}
      <img src={star_img} alt="" class="star_icon2" />
    </section>
  );
};

export default HomeCom;
